import { DealStage } from 'api/models';

export const DealStageConfig: Partial<Record<DealStage, { key: string; title: string; color: string }>> = {
  [DealStage.InProgress]: { key: 'deal.stage.inProgress', title: 'In Progress', color: 'cyan' },
  [DealStage.ClosedWon]: { key: 'deal.stage.closedWon', title: 'Closed Won', color: 'green' },
  [DealStage.ClosedLost]: { key: 'deal.stage.closedLost', title: 'Closed Lost', color: 'red' },
};

export const getStageColor = (stage: DealStage) => {
  switch (stage) {
    case DealStage.InProgress: // In Progress
      return '#13c2c2';
    case DealStage.ClosedWon: // Closed Won
      return '#52c41a';
    case DealStage.ClosedLost: // Closed Lost
      return '#ff4d4f';
    default:
      return '#d9d9d9';
  }
};

export const getStageName = (stage: DealStage) => {
  return DealStageConfig[stage];
};
